import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	//파라미터가 없을경우
	// getTableList: () => {
	//파라미터가 있을경우
	getUploadFormList: params => {
		//console.log('조회 파라미터 확인 :::: ', params);
		const queryParams = Object.entries(params)
			.filter(([key, val]) => val)
			.map(([key, val]) => `${key}=${val}`)
			.join('&');
		//console.log(queryParams);
		return client.get(`${BASE_URL}/uploadForm/v1/uploadForms?${queryParams}`).then(res => res.data);

		// let url = `${BASE_URL}/uploadForm/v1/uploadForms?gqmsSeq=${gqmsSeq}&gqmsTitle=${gqmsTitle}&gqmsConts=${gqmsConts}&currentPage=${currentPage}&pageUnit=${pageUnit}`;
		// return client
		// 	.get(url)
		// 	.then(response => (response && response.data) || null)
		// 	.catch(error => console.log(error));

		// return client
		// 	.get(
		// 		`${BASE_URL}/uploadForm/v1/uploadForms?gqmsSeq=${gqmsSeq}&gqmsTitle=${gqmsTitle}&gqmsConts=${gqmsConts}&currentPage=${currentPage}&pageUnit=${pageUnit}'`
		// 	)
		// 	.then(res => res.data);
	},
	selectOptions: () => {
		return client.get(`${BASE_URL}/uploadForm/v1/options`).then(res => res.data);
	},

	selectCommCdTypeList: ({ commCdType, useYn, currentPage, pageUnit, commCdTypeName }) => {
		const params = { commCdTypeName, pageUnit, currentPage };
		const queryString =
			'?' +
			Object.entries(params)
				.map(([key, val]) => (!_.isNil(val) ? `${key}=${val}` : ''))
				.filter(r => r)
				.join('&');
		return client.get(`${BASE_URL}/commonCode/v1/commCdType/${commCdType}/useYn/${useYn}` + queryString).then(res => res.data);
	},
	selectCommCdList: ({ commCdType, currentPage, pageUnit }) =>
		client
			.get(`${BASE_URL}/commonCode/v1/commCdType/${commCdType}/commCd?currentPage=${currentPage}&pageUnit=${pageUnit}`)
			.then(res => res.data),

	select: params => {
		// console.log(params);
		const queryParams = Object.entries(params)
			.filter(([key, val]) => val)
			.map(([key, val]) => `${key}=${val}`)
			.join('&');
		//console.log(queryParams);
		return client.get(`${BASE_URL}/uploadForm/v1/uploadForms?${queryParams}`).then(res => res.data);
	},
	getUseYnList: (plantCd, commCdType) =>
		client.post(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${commCdType}`).then(res => res.data),
	addUploadForm: ({ formData }) => {
		let url = `${BASE_URL}/uploadForm/v1/status/1/uploadForms`;
		for (var pair of formData.entries()) {
			//console.log(pair[0] + ', ' + pair[1]);
		}
		return client
			.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
			.then(response => (response && response.data) || null)
			.catch(error => console.log(error));
	},
	fileDownload: ({ params }) => {
		// console.log('params', params);
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/uploadForm/v1/downloadFile`, params, { responseType: 'blob' })
				.then(response => {
					resolve(response);
				})
				.catch(error => reject(new Error(error.message || error.response)));
		});
	},

	//수정 저장시 사용
	saveUploadForm: ({ formData }) => {
		let url = `${BASE_URL}/uploadForm/v1/status/2/uploadForms`;
		// for (var pair of formData.entries()) {
		// 	console.log(pair[0] + ', ' + pair[1]);
		// }
		return client
			.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
			.then(response => (response && response.data) || null)
			.catch(error => console.log(error));
	},

	getUpdateFormList: ({ gqmsSeq, gqmsTitle, gqmsConts, currentPage, pageUnit }) => {		
		let url = `${BASE_URL}/uploadForm/v1/uploadForms?gqmsSeq=${gqmsSeq}&gqmsTitle=${gqmsTitle}&gqmsConts=${gqmsConts}&currentPage=${currentPage}&pageUnit=${pageUnit}`;
		//console.log('실제 url ', url);
		//let url = `${BASE_URL}/uploadForm/v1/uploadForms?gqmsSeq=${gqmsSeq}&gqmsTitle=${gqmsTitle}&gqmsConts=${gqmsConts}`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => console.log(error));
	},

	// 삭제 버튼을 클릭했을때
	delUploadForm: ({ params }) => {
		//console.log('params ::: {}', params);
		let url = `${BASE_URL}/uploadForm/v1/status/3/uploadForms?gqmsSeq=${params.gqmsSeq}`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => console.log(error));
	},

	selectOne_: ({ gqmsSeq }) => {
		//console.log('gqmsSeq ::: {}', gqmsSeq);
		let url = `${BASE_URL}/uploadForm/v1/uploadForms/${gqmsSeq}`;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => console.log(error));
	}
};
